export const accountFirstName = {
  type: "string",
  minLength: 1,
  maxLength: 255
};
